import React from "react";
import { useNavigate } from "react-router-dom";
import Arrow from "../../../../assets/img/BackArrow.png";
import LeftArrow from "../../../../assets/svg/LeftArrow.svg";
import styles from "../../Introspekcije.module.css";

function Navigation({
  initialRoute,
  title,
  disabledPrevious,
  introspectionId,
  programId,
  introspectionNumber,
  disabledNext,
}) {
  const navigate = useNavigate();
  return (
    <div className={styles.navWrapper}>
      <div
        className={styles.backRow}
        onClick={() => navigate(initialRoute.current)}
      >
        <img alt="" src={Arrow} />
        <p className={styles.back}>Natrag</p>
      </div>
      <div style={{ width: "100%", marginTop: "-50px" }}>
        <p className={styles.title}>{title}</p>
      </div>
      <div className={styles.navContainer}>
        <div
          className={styles.element}
          style={{
            cursor: disabledPrevious ? "not-allowed" : "pointer",
            opacity: disabledPrevious ? 0.6 : 1,
          }}
          onClick={() => {
            if (!disabledPrevious) {
              navigate(`/introspekcije-polaznik/${introspectionId - 1}`, {
                state: { programId: programId, title: title },
              });
            }
          }}
        >
          <img src={LeftArrow} alt="" />
          <p className={styles.paragraph}>Prethodna</p>
        </div>
        <p className={styles.paragraph} style={{ fontSize: 20 }}>
          {introspectionNumber}. Introspekcija
        </p>
        <div
          className={styles.element}
          style={{
            cursor: disabledNext ? "not-allowed" : "pointer",
            opacity: disabledNext ? 0.6 : 1,
          }}
          onClick={() => {
            if (!disabledNext) {
              navigate(`/introspekcije-polaznik/${introspectionId + 1}`, {
                state: { programId: programId, title: title },
              });
            }
          }}
        >
          <p className={styles.paragraph}>Sljedeća</p>
          <img src={LeftArrow} alt="" style={{ transform: "rotate(180deg)" }} />
        </div>
      </div>
    </div>
  );
}

export default Navigation;
